/* eslint-disable no-param-reassign */
import { Window } from '../../../00_IMMEDIATE/Window';
import OMT_UI_SquareButton, { BUTTONCOLOURS } from '../../../OMT_UI/OMT_UI_SquareButton';

const WINDOW_OFFSET_Y = 70;

const BG_WIDTH = 620;
const BG_HEIGHT = 860;
const BG_Y = -20;

const CLOSE_BUTTON_X = 290;
const CLOSE_BUTTON_Y = -BG_HEIGHT / 2;
const CLOSE_BUTTON_ROTATION = 0;

const PLAY_BUTTON_X = 0;
const PLAY_BUTTON_Y = (BG_HEIGHT / 2) - 130;

/**
 * Class for fullscreen cross promo overlay
 */
class Window_CrossPromoOverlay extends Window {
  /**
   * constructor
   * @param {Object} parent
   * @param {Object} crossPromoData
   * @param {Object} assetsData
   * @param {string} trackingName
   * @param {Function} callback
   */
  constructor(parent, crossPromoData, assetsData, trackingName, callback = null) {
    super(parent);

    this._crossPromoData = crossPromoData;
    this._targetedAppID = crossPromoData.targetedApp.id;
    this._trackingName = trackingName;
    this._callback = callback;

    this._initLayout();

    this._loadPromoAssets(assetsData);

    this._initButtons();

    console.log('this._crossPromoData');
  }

  /**
   * init window layout items
   */
  _initLayout() {
    // offset for world scene only
    if (game.state.getCurrentState().key === 'World') this.y += WINDOW_OFFSET_Y;

    this._bg = this.addGeneric9SliceBackground(BG_WIDTH, BG_HEIGHT);
    this._bg.y = BG_Y;
  }

  /**
   * init window buttons
   */
  _initButtons() {
    // close button
    this._closeBtn = new G.Button(CLOSE_BUTTON_X, CLOSE_BUTTON_Y, 'btn_x', () => {
      this.closeWindow(() => {
        if (this._callback) this._callback();
      });
    }, this);
    this.registerButtons(this._closeBtn);
    this._closeBtn.rotation = CLOSE_BUTTON_ROTATION;

    // play promo game buttons
    const onCrossAccept = () => {
      this._onCrossPromoAccept();
    };
    this._promoBtn = new OMT_UI_SquareButton(PLAY_BUTTON_X, PLAY_BUTTON_Y, {
      button: {
        tint: BUTTONCOLOURS.orange,
        dimensions: {
          width: 196,
          height: 100,
        },
      },
      text: {
        string: OMT.language.getText('Play'),
        textStyle: { style: 'font-white', fontSize: 48 },
      },
      options: {
        clickFunction: {
          onClick: onCrossAccept.bind(this),
        },
        pulse: 1.1,
      },
    });
    this.addChild(this._promoBtn);
    this.registerButtons(this._promoBtn);
  }

  /**
   * load the cross promo assets
   * @param {Object} assetsData
   */
  _loadPromoAssets(assetsData) {
    this._img = G.makeExtImage(0, 0, assetsData.src, '', [0.5, 0.5], this, false, (img) => {
      img.alpha = 0;
      game.add.tween(img).to({ alpha: 1 }, 250, Phaser.Easing.Quadratic.Out, true);
    });
    this._img.alpha = 0;
    this.addChildAt(this._img, 1);
  }

  /**
   * on cross promo user activation
   */
  async _onCrossPromoAccept() {
    // track promo clicked
    const trackingEventName = OMT.platformTracking.Events.XPromoClicked.replace('%id%', this._trackingName);
    OMT.platformTracking.logEvent(trackingEventName);

    this._promoBtn.stopPulse();
    this.showOverlay();

    // eslint-disable-next-line no-unused-vars
    await window.OMT.crossPromo.switchToAnotherGame(this._crossPromoData);
    this.hideOverlay();
  }
}

// create global references
if (!window.Windows) window.Windows = {};
Windows.crossPromoOverlay = Window_CrossPromoOverlay;
